import {
  FetchProductsResponse, FetchProductsParams
} from "@/types/models/services/products";
import API from "@/services/api";
import { FetchAccessTariffsParams, FetchAccessTariffsResponse } from "../types/accessTariffs";

enum Endpoints {
	Tariff = "/tariff",
	GasTariff = "/gas/tariff"
}

const fetchAccessTariffs = ({
	power,
}: FetchAccessTariffsParams
) => {
	return new Promise<FetchAccessTariffsResponse>(async (resolve, reject) => {
		API.get<FetchAccessTariffsResponse>({
			endpoint: Endpoints.Tariff,
			searchParams: [
				'?power', '=', power,
			].join('')
		})
		.then(res => {
			resolve(res.promise.data)
		})
		.catch(err => {
			reject(err);
		})
	})
}

const fetchGasAccessTariffs = () => {
  return new Promise<FetchAccessTariffsResponse>(async (resolve, reject) => {
    API.get<FetchAccessTariffsResponse>({
      endpoint: Endpoints.GasTariff,
			versions: [2]
    })
      .then(res => {
        resolve(res.promise.data)
      })
      .catch(err => {
        reject(err);
      })
  })
}

export default {
  fetchAccessTariffs,
  fetchGasAccessTariffs
};


